'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagRwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.50225e-05 6.4075e-06C9.33339 -6.03797e-05 18.6667 0 28.0001 0C28.0001 6.66667 28.0001 13.3333 28.0001 20C18.6667 20 9.33333 20 -3.05176e-05 20L5.50225e-05 6.4075e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-3.05176e-05 20H28.0001V14.6667H5.50225e-05L-3.05176e-05 20Z",
          fill: "#2D754D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.50225e-05 9.33333H28.0001V0L5.50225e-05 6.4075e-06V9.33333Z",
          fill: "#25B1EB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.50225e-05 14.6667H28.0001V9.33333H5.50225e-05V14.6667Z",
          fill: "#FECB2F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3334 6L20.3129 7.13035L20.3906 5.60948L18.8697 5.68716L20.0001 4.66667L18.8697 3.64618L20.3906 3.72386L20.3129 2.20299L21.3334 3.33333L22.3539 2.20299L22.2762 3.72386L23.7971 3.64618L22.6667 4.66667L23.7971 5.68716L22.2762 5.60948L22.3539 7.13035L21.3334 6Z",
          fill: "#FECB2F"
        }
      )
    ]
  }
);
const VpFlagRwAsset = forwardRef(FlagRwAsset);

export { VpFlagRwAsset as default };
